var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.IsEmailEnabled()
    ? _c("div", { attrs: { id: "mailbox" } }, [
        _c(
          "div",
          { staticClass: "route-page-content" },
          [
            _c("SidebarChild", {
              attrs: {
                selectedItem: _vm.selectedTab,
                items: _vm.menuItems,
                focusActive: true,
                className: "mail-menu",
              },
              on: { selected: _vm.handleSidebarSelection },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "page-content-wrapper" },
              [
                _vm.isSelected("templates") ? _c("EmailTemplates") : _vm._e(),
                _vm._v(" "),
                _vm.isSelected("broadcast")
                  ? _c("EmailBroadcastList")
                  : _vm._e(),
                _vm._v(" "),
                _vm.isSelected("customer-groups")
                  ? _c("EmailCustomerGroups")
                  : _vm._e(),
                _vm._v(" "),
                _vm.isSelected("inbox") ? _c("NewMailInterface") : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }